import { render, staticRenderFns } from "./rawData.vue?vue&type=template&id=2ec61a3d&"
import script from "./rawData.vue?vue&type=script&lang=ts&"
export * from "./rawData.vue?vue&type=script&lang=ts&"
import style0 from "./rawData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports